import { ISSUE_CONTEXT_MENU_SERVICE_NAME, IssueContextMenuServiceProvider } from './issue.context-menu.service'

export const ISSUE_SERVICES_MODULE_NAME = 'simax.services.issue'

const module = angular.module(ISSUE_SERVICES_MODULE_NAME, [])

module.provider(ISSUE_CONTEXT_MENU_SERVICE_NAME, IssueContextMenuServiceProvider)
